export default function getPaginationParams(registrations, limit = 10) {
  const { count, next, page, previous } = registrations;
  const pages = Math.ceil(Number(count) / limit);
  const first = Math.max(page - 3, 1);
  const last = Math.min(first + 3, pages);
  const pagesArray = [];
  for (let i = first; i <= last; i += 1) {
    pagesArray.push({
      number: i,
      clickable: i !== page,
    });
  }
  return {
    show_first: pages > 1,
    show_last: pages > 1,
    has_previous: !!previous,
    has_next: !!next,
    pages: pagesArray,
    current: page,
    last: pages,
  };
}
